import { getKeyLabel } from './controls.utils';
import { GamepadBinding, KeyboardBinding } from '../types/types';
import { DirectionEnum } from '../types/enums';

export function formatKeyboardBinding(binding: KeyboardBinding): string {
  const modifiers = (binding.modifiers ?? []).map(getKeyLabel).join(' + ');
  const key = getKeyLabel(binding.code);
  return modifiers ? `${modifiers} + ${key}` : key;
}

export function formatGamepadBinding(binding: GamepadBinding): string {
  switch (binding.type) {
    case 'button':
      return binding.label;
    case 'axis':
      return binding.label;
    case 'combo':
      return `${binding.modifierLabel} + ${binding.buttonLabel}`;
  }
}

export const hasTarget = (event: KeyboardEvent): boolean => {
  const target = event.target as HTMLElement;
  return (
    target.tagName === 'INPUT' ||
    target.tagName === 'TEXTAREA' ||
    target.tagName === 'SELECT'
  );
};

export interface DirectionInput {
  up: boolean;
  down: boolean;
  left: boolean;
  right: boolean;
}

export function resolveDirection(
  dir: DirectionInput,
  lockDiagonal: boolean,
): DirectionEnum | null {
  const { up, down, left, right } = dir;

  if (!up && !down && !left && !right) {
    return null;
  }

  const vertUp = up && !down;
  const vertDown = down && !up;
  const horizLeft = left && !right;
  const horizRight = right && !left;

  if (lockDiagonal) {
    // Diagonal-lock mode keeps only diagonals; a lone cardinal is ignored.
    if (vertUp && horizLeft) {
      return DirectionEnum['TOP-LEFT'];
    }
    if (vertUp && horizRight) {
      return DirectionEnum['TOP-RIGHT'];
    }
    if (vertDown && horizLeft) {
      return DirectionEnum['BOTTOM-LEFT'];
    }
    if (vertDown && horizRight) {
      return DirectionEnum['BOTTOM-RIGHT'];
    }
    return null;
  }

  if (vertUp && horizLeft) {
    return DirectionEnum['TOP-LEFT'];
  }
  if (vertUp && horizRight) {
    return DirectionEnum['TOP-RIGHT'];
  }
  if (vertDown && horizLeft) {
    return DirectionEnum['BOTTOM-LEFT'];
  }
  if (vertDown && horizRight) {
    return DirectionEnum['BOTTOM-RIGHT'];
  }
  if (vertUp) {
    return DirectionEnum.TOP;
  }
  if (vertDown) {
    return DirectionEnum.BOTTOM;
  }
  if (horizLeft) {
    return DirectionEnum.LEFT;
  }
  if (horizRight) {
    return DirectionEnum.RIGHT;
  }

  return null;
}
